import React from "react";
import { Radio } from "@mui/material";
import styles from "./ConfigStage.module.css";
import { isSegFeatureEnabled, SegFlags, translate } from "../../../../../../../../../providers";
import { CustomTooltip } from "../../../../../../../../tooltip";
import { icon, IconComponent } from "../../../../../../../../icon-component";
import { isNonEmptyArray } from "../../../../../../../../../utils";
import { CommonFilters, DocumentFilter, FiltersWrapper } from "../../../../../../../../filters5";
import { DOCUMENT_OPTION } from "../../../../../../../../../constants";
import { CustomTextField } from "../../../../../../../../text-fields";

const ConfigStage = ({
	actionOption,
	actionOptions = [],
	actionOptionsTitle = "",
	documentOption,
	documentOptions = [],
	documentOptionsTitle = "",
	instructions = "",
	isTemplate = false,
	onChangeActionOption,
	onChangeDocumentOption,
	onChangeDocuments,
	onChangeInstructions = null,
	promptHoverText = "",
	promptPlaceholder = "",
	promptTitle = "",
	selectedDocuments = {},
	totalDocuments = 0,
}) => {
	const handleChangeInstruction = (e) => {
		onChangeInstructions(e.target.value);
	};
	return (
		<div>
			<div className={styles.bodyElement}>
				<div className={styles.bodyElement__title}>
					{promptTitle || translate("common:component.ai.config-instructions")}
					<span className={styles.asterix}>*</span>
					{promptHoverText && (
						<CustomTooltip title={promptHoverText}>
							<IconComponent color="var(--grey-500)" icon={icon.faInfoCircle} />
						</CustomTooltip>
					)}
				</div>
				<CustomTextField
					autoFocus
					fullWidth
					multiline
					required
					InputProps={{
						classes: {
							input: styles.inputBase,
						},
					}}
					placeholder={promptPlaceholder || translate("common:component.ai.config-instructions.placeholder")}
					rows={7}
					size="small"
					value={instructions}
					variant="outlined"
					onChange={handleChangeInstruction}
				/>
			</div>
			{!isTemplate && (
				<div className={styles.bodyElement__middle}>
					<div className={`${styles.bodyElement__title} ${styles["bodyElement__title--padded"]}`}>
						{documentOptionsTitle || translate("common:component.ai.document-choice-for-analysis")}
					</div>
					<div>
						{isNonEmptyArray(documentOptions) &&
							documentOptions.map((option) => (
								<React.Fragment key={option.value}>
									<div
										className={styles.radios__container}
										role="presentation"
										onClick={() => {
											onChangeDocumentOption(option.value);
										}}
									>
										<Radio
											disableRipple
											checked={option.value === documentOption}
											color="primary"
											sx={{
												p: 0,
											}}
										/>
										<span className={styles.radios__label}>{option.label}</span>
									</div>
									{option.value === DOCUMENT_OPTION.MANUAL &&
										documentOption === DOCUMENT_OPTION.MANUAL && (
											<div className={styles.documentSelectorWrapper}>
												<FiltersWrapper
													multiline
													className={styles.documentSelector}
													components={[
														{
															default: true,
															enabled: isSegFeatureEnabled(SegFlags.DOCUMENT_CENTER),
															component: CommonFilters.DOCUMENTS,
															label: "common:filter.documents.select",
															renderer: <DocumentFilter />,
															withDescription: false,
														},
													]}
													defaultFilters={selectedDocuments}
													filterPopUpPlacement="top-start"
													onApply={onChangeDocuments}
												/>
												{isNonEmptyArray(selectedDocuments?.documents?.elements) && (
													<div className={styles.counter}>
														{translate(
															"common:component.ai-config.manual-document-selection.counter",
															{
																count: selectedDocuments.documents?.is
																	? selectedDocuments.documents?.elements?.length
																	: totalDocuments -
																	  selectedDocuments.documents.elements.length,
																total: totalDocuments,
															}
														)}
													</div>
												)}
											</div>
										)}
								</React.Fragment>
							))}
					</div>
				</div>
			)}
			{isNonEmptyArray(actionOptions) && (
				<div className={styles.bodyElement__bottom}>
					<div className={`${styles.bodyElement__title} ${styles["bodyElement__title--padded"]}`}>
						{actionOptionsTitle ||
							translate("common:component.ai-config.detected-content-integration.question")}
					</div>
					<div>
						{actionOptions.map((option) => (
							<div
								key={option.value}
								role="presentation"
								onClick={() => {
									onChangeActionOption(option.value);
								}}
							>
								<Radio
									disableRipple
									checked={option.value === actionOption}
									color="primary"
									sx={{
										p: 0,
									}}
								/>
								<span className={styles.radios__label}>{option.label}</span>
							</div>
						))}
					</div>
				</div>
			)}
		</div>
	);
};

export default ConfigStage;
